import React, { useState, useEffect } from 'react';
import { FiMessageCircle } from 'react-icons/fi';

const QuestionGenerator = ({ questions, onQuestionSelect }) => {
    const [displayedQuestions, setDisplayedQuestions] = useState([]);

    useEffect(() => {
        // Randomly select 3 unique questions
        const shuffled = [...questions].sort(() => 0.5 - Math.random());
        setDisplayedQuestions(shuffled.slice(0, 3));
    }, [questions]);

    const handleBoxClick = (questionText) => {
        onQuestionSelect(questionText);
    };

    const handleNewChat = () => {
        window.location.replace(window.location.pathname);
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
            {displayedQuestions.map((q, index) => (
                <div
                    key={index}
                    className="p-3 bg-blue-50 hover:bg-blue-100 text-blue-800 border border-blue-200 text-sm font-bold font-noto-sans rounded-lg cursor-pointer transition-all duration-200 shadow-md hover:shadow-lg"
                    onClick={() => handleBoxClick(q)}
                >
                    {q}
                </div>
            ))}
            <div
                className="p-3 bg-blue-50 hover:bg-blue-100 text-blue-800 border border-blue-200 text-sm font-bold font-noto-sans rounded-lg cursor-pointer transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center"
                onClick={handleNewChat}
            >
                <FiMessageCircle className="w-4 h-4 mr-2" />
                <span>New chat</span>
            </div>
        </div>
    );
};

export default QuestionGenerator;